import { ClipboardList, Mail } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { openEmailPreview } from '~/pages/messages/openEmailPreview';
import type { PackingListNotificationMessage } from '~/pages/messages/Messages';

export function PackingListNotificationCard({
  msg,
}: Readonly<{ msg: PackingListNotificationMessage }>) {
  const { t } = useTranslation('messages');
  const navigate = useNavigate();
  const { emailHtmlBody } = msg;

  const title =
    msg.chatType === 'PACKING_LIST_CREATED_BUYER'
      ? t('messages.packing_list_notification.title_created', {
          orderNumber: msg.orderNumber,
        })
      : t('messages.packing_list_notification.title_updated', {
          orderNumber: msg.orderNumber,
        });

  return (
    <div className="flex flex-col items-center gap-1">
      <span className="text-xs text-neut-400">{msg.timestamp}</span>
      <div className="w-full max-w-md rounded-2xl p-4 border bg-amber-50 border-amber-200">
        <div className="flex items-start gap-3">
          <ClipboardList size={18} className="text-amber-600 shrink-0 mt-0.5" />
          <div className="flex-1">
            <p className="text-sm font-semibold text-amber-800">{title}</p>
            <p className="text-xs text-neut-500 mt-2">
              {t('messages.packing_list_notification.description')}
            </p>
            <div className="flex gap-2 mt-2.5">
              <button
                onClick={() => navigate(`/orders/view/${msg.orderId}`)}
                className="flex items-center gap-1 px-2.5 py-1 border border-neut-200 rounded-lg text-[10px] text-neut-500 hover:bg-neut-bg-alt transition-colors bg-neut-bg-alt"
              >
                <ClipboardList size={10} />
                {t('messages.packing_list_notification.view_packed_items')}
              </button>
              {emailHtmlBody && (
                <button
                  onClick={() => openEmailPreview(emailHtmlBody)}
                  className="flex items-center gap-1 px-2.5 py-1 border border-neut-200 rounded-lg text-[10px] text-neut-500 hover:bg-neut-bg-alt transition-colors bg-neut-bg-alt"
                >
                  <Mail size={10} />
                  {t('messages.packing_list_notification.preview_email')}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
